const getBrowseConfig = apiClient => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/browse`;

  return apiClient.get(route);
};

const getBrowseCategoryConfig = (apiClient, categoryPath) => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/browse/categories${categoryPath}`;

  return apiClient.get(route);
};

export { getBrowseConfig, getBrowseCategoryConfig };
